import { PATH_DASHBOARD } from 'src/routes/paths';

const handleDonationRedirection = (donation) => {
  if (donation.is_partial) {
    if (donation.rescue_id) {
      return PATH_DASHBOARD.viewPartialDonation(
        donation.id,
        donation.rescue_id
      );
    }
    return PATH_DASHBOARD.viewDonation(donation.id);
  }
  // The incomplete-rescues listing is built from the shared rescue query.
  // That query exposes the food-mover team but does not expose d.is_food_run,
  // so retain the legacy food-run signal for rows opened from that screen.
  if (donation.is_food_run || donation.food_mover_team_id) {
    return PATH_DASHBOARD.viewFoodRun(donation.id);
  }
  return PATH_DASHBOARD.viewDonation(donation.id);
};

export default handleDonationRedirection;
